// src/pages/FreeConsult.jsx
import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import ChatRoom from "../components/ChatRoom";
import { GraduationCap, Heart, Home, HelpCircle } from "lucide-react";

const CATEGORIES = [
  { id: "school",    icon: <GraduationCap size={28} />, ar: "استشارات مدرسية",  en: "School Consultations" },
  { id: "parenting", icon: <Heart size={28} />,          ar: "تربية الأبناء",    en: "Parenting" },
  { id: "family",    icon: <Home size={28} />,           ar: "مشكلات أسرية",    en: "Family Issues" },
  { id: "other",     icon: <HelpCircle size={28} />,     ar: "أخرى",            en: "Other" }
];

export default function FreeConsult() {
  const { user } = useAuth();
  const { lang } = useLanguage();
  const [category, setCategory] = useState(null);

  const chatId = category ? `free_${user?.uid}_${category}` : null;

  return (
    <div className="page-content fade-in">
      <div className="container-md">
        <div style={{ marginBottom: "1.5rem" }}>
          <h2>{lang === "ar" ? "الاستشارة النفسية المجانية" : "Free Psychological Consultation"}</h2>
          <p className="text-muted text-sm" style={{ margin: 0 }}>
            {lang === "ar" ? "اختر نوع الاستشارة للتواصل مع المتخصص" : "Select consultation type to connect with a specialist"}
          </p>
        </div>

        {!category ? (
          <>
            <p style={{ marginBottom: "1.25rem", fontWeight: 600 }}>
              {lang === "ar" ? "ما الذي تود الاستشارة فيه؟" : "What would you like to consult about?"}
            </p>
            <div className="grid-2">
              {CATEGORIES.map(cat => (
                <button
                  key={cat.id}
                  onClick={() => setCategory(cat.id)}
                  style={{
                    background: "var(--color-white)",
                    border: "2px solid var(--color-gray-200)",
                    borderRadius: "var(--radius-lg)",
                    padding: "1.75rem 1.25rem",
                    cursor: "pointer",
                    textAlign: "center",
                    transition: "all 0.2s",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontFamily: "inherit"
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--color-forest)"; e.currentTarget.style.background = "var(--color-forest-lt)"; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--color-gray-200)"; e.currentTarget.style.background = "var(--color-white)"; }}
                >
                  <span style={{ color: "var(--color-forest)" }}>{cat.icon}</span>
                  <span style={{ fontWeight: 700, fontSize: "1rem", color: "var(--color-gray-700)" }}>
                    {lang === "ar" ? cat.ar : cat.en}
                  </span>
                </button>
              ))}
            </div>
          </>
        ) : (
          <>
            <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1.25rem" }}>
              <button
                onClick={() => setCategory(null)}
                className="btn btn-ghost btn-sm"
              >
                {lang === "ar" ? "← تغيير النوع" : "← Change type"}
              </button>
              <div className="badge badge-blue">
                {lang === "ar"
                  ? CATEGORIES.find(c => c.id === category)?.ar
                  : CATEGORIES.find(c => c.id === category)?.en}
              </div>
            </div>
            <ChatRoom chatId={chatId} title="" />
          </>
        )}
      </div>
    </div>
  );
}
